import { useCallback, useMemo, useState } from "react";

import { ChevronRight } from "components/icons/generated";
import Button from "ds/components/Button";
import DropdownMenu from "ds/components/DropdownMenu";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import useTypedContext from "hooks/useTypedContext";

import { ProviderVersionDocsContext } from "./Context";
import styles from "./styles.module.css";

const ProviderVersionDropdown = () => {
  const { provider, version } = useTypedContext(ProviderVersionDocsContext);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenChange = useCallback((newValue: boolean) => {
    setIsOpen(newValue);
  }, []);

  const versions = useMemo(
    () => provider.versions.filter((v) => v.docs.overviewContent),
    [provider.versions]
  );

  return (
    <DropdownMenu
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
      className={styles.versionDropdown}
      triggerComponent={
        <Button
          variant="secondary"
          active={isOpen}
          endIcon={ChevronRight}
          endIconRotate={isOpen ? "270" : "90"}
        >
          {`Version: ${version.number}`}
        </Button>
      }
    >
      {versions.length === 0 && <DropdownMenuItem isDisabled>No other version</DropdownMenuItem>}
      {versions.map((v) => (
        <DropdownMenuItem
          key={v.id}
          href={`/provider/${provider.id}/version/${v.number}/docs`}
          active={v.number === version.number}
        >
          {v.number}
        </DropdownMenuItem>
      ))}
    </DropdownMenu>
  );
};

export default ProviderVersionDropdown;
